/* The theme refreshes its cart quantity before emitting these events. */
if (!customElements.get('eo-cart-count')) {
  customElements.define('eo-cart-count', class extends HTMLElement {
    connectedCallback() {
      this.updateCount = () => {
        const quantity = document.querySelector('[data-cart-items-qty]');
        const count = Number.parseInt(quantity?.textContent, 10);
        if (Number.isFinite(count) && count >= 0) this.textContent = count > 99 ? '99+' : String(count);
      };
      document.addEventListener('theme:cart:added', this.updateCount);
      document.addEventListener('theme:cart:loaded', this.updateCount);
    }

    disconnectedCallback() {
      document.removeEventListener('theme:cart:added', this.updateCount);
      document.removeEventListener('theme:cart:loaded', this.updateCount);
    }
  });
}
